export default __webpack_public_path__ + "static/fh-favicon-574efb5da4fbd2a3689e09ce4113c552.png";